export default {"src":"/_next/static/image/public/icons/linkedIn.e643dc2c511f43f79d90e96b3c4ab547.svg","height":20,"width":23};